import { checkIfNewUser, getAppConfig } from '@/api/app'
import { APP_CONFIG_KEY, REQUEST_SUCCESS_CODE } from '../../config/constant'
import { getStorageLanguage } from '@/utils/language.ts'

export interface AppState {
    appConfig: any
    language: string
    appStoreRating: any
}

const state: AppState = {
    appConfig: {},
    appStoreRating: '4.8',
    language: getStorageLanguage()
}

const getters = {
    appConfig: (state: AppState) => state.appConfig,

    language: (state: AppState) => state.language
}

const mutations = {
    SET_APP_CONFIG(state: AppState, appConfig: any) {
        state.appConfig = appConfig
    },
    SET_APP_STORE_RATING(state: AppState, appStoreRating: string) {
        state.appStoreRating = appStoreRating
    }
}

const actions = {
    // 设置主题
    async setAppConfig({ commit }: any) {
        try {
            const appConfig = await getAppConfig()
            const isNewUser = await checkIfNewUser()

            if (appConfig.code != REQUEST_SUCCESS_CODE) {
                throw new Error('获取应用配置失败')
            }

            if (isNewUser.code != REQUEST_SUCCESS_CODE) {
                throw new Error('获取新用户失败')
            }

            const appConfigData = {
                ...appConfig.data,

                isNewUser: isNewUser.data?.newUser,

                testPrepQtTm: {
                    list: [
                        {
                            number: 5,
                            time: 10
                        },
                        {
                            number: 10,
                            time: 20
                        },
                        {
                            number: 15,
                            time: 30
                        },
                        {
                            number: 20,
                            time: 40
                        }
                    ],
                    defaultNumber: 10
                }
            }

            localStorage.setItem(APP_CONFIG_KEY, JSON.stringify(appConfigData))

            commit('SET_APP_CONFIG', appConfigData)
        } catch (error) {
            console.error('获取应用配置失败:', error)

            const appConfigData = localStorage.getItem(APP_CONFIG_KEY) || '{}'

            commit('SET_APP_CONFIG', appConfigData)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
